import { selectFeatureFlags } from 'flow/selectors/feature-flag-selectors';
import { FeatureFlagTypes } from 'flow/types/FeatureFlags';
import { featureFlagCheck } from 'flow/utils/feature-flag-utils';
import { useAppSelector } from './useRedux';

export const FeatureFlags = Object.freeze({
    USE_V1_UI: 'USE_V1_UI',
    HAS_V2_TOGGLE_BUTTON: 'HAS_V2_TOGGLE_BUTTON',
    HAS_GLOBAL_STATE_VIEWER_TOGGLE_BUTTON:
        'HAS_GLOBAL_STATE_VIEWER_TOGGLE_BUTTON',
    DARK_MODE: 'DARK_MODE',
    VIDEO_CANVAS: 'VIDEO_CANVAS',
    SEND_TICKET_ATTACHMENT: 'SEND_TICKET_ATTACHMENT',
    REACTIONS: 'REACTIONS',
    QUOTED_REPLIES: 'QUOTED_REPLIES',
    THREADS: 'THREADS',
    SETTINGS_ON_BEHALF: 'SETTINGS_ON_BEHALF',
    MARKDOWN: 'MARKDOWN',
    KEYBOARD_SHORTCUTS: 'KEYBOARD_SHORTCUTS',
    SHOW_STATS_INSIGHTS: 'SHOW_STATS_INSIGHTS',
    AI_SUMMARIZE_UNREAD_MESSAGES: 'AI_SUMMARIZE_UNREAD_MESSAGES',
    CAN_AUTO_TRANSCRIBE_WITHOUT_RECORDED_CALLS:
        'CAN_AUTO_TRANSCRIBE_WITHOUT_RECORDED_CALLS',
    EASTER_EGGS: 'EASTER_EGGS',
    SHOW_TRANSFER_BUTTON_IN_DOUBLE_CALL: 'SHOW_TRANSFER_BUTTON_IN_DOUBLE_CALL',
    TICKETS_ADVANCED_SEARCH: 'TICKETS_ADVANCED_SEARCH',
    FARO_OBSERVABILITY: 'FARO_OBSERVABILITY',
    TICKETS_FORWARD_TO_QUEUE: 'TICKETS_FORWARD_TO_QUEUE',
    TICKETS_SET_ACCESS_LEVEL: 'TICKETS_SET_ACCESS_LEVEL',
});

interface FeatureFlagHook {
    hasFeature: (
        feature: FeatureFlagTypes | FeatureFlagTypes[],
        requireAll?: boolean,
    ) => boolean;
}

const useFeatureFlags = (): FeatureFlagHook => {
    const listFeatureFlags = useAppSelector(selectFeatureFlags);

    const hasFeature = (
        features: FeatureFlagTypes | FeatureFlagTypes[],
        requireAll = false,
    ): boolean => {
        if (Array.isArray(features)) {
            return requireAll
                ? features.every((feature) =>
                      featureFlagCheck(listFeatureFlags, feature),
                  )
                : features.some((feature) =>
                      featureFlagCheck(listFeatureFlags, feature),
                  );
        }

        return featureFlagCheck(listFeatureFlags, features);
    };

    return { hasFeature };
};

export default useFeatureFlags;
